<div *ngFor="let block of body; index as i; first as isFirst; last as isLast">
  <div class="p8-bdc_page-block__block-container" (mouseenter)="onMouseEnter(i)">
    <p8-bdc-edit-text *ngIf="block.type === 'text'" [block]="block"></p8-bdc-edit-text>
    <p8-bdc-edit-image *ngIf="block.type === 'image'" [block]="block" (blockChange)="onBlockImageChange($event)"></p8-bdc-edit-image>

    <div class="p8-bdc_edit-text__buttons-container p8-secondary" fxLayout="row">
      <button mat-icon-button [disabled]="isFirst" (click)="moveUp(i)">
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <button mat-icon-button [disabled]="isLast" (click)="moveDown(i)">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      <button mat-icon-button (click)="remove(i)">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="p8-bdc_page-block_add-block-container" fxLayout="row" fxLayoutAlign="center" *ngIf="currentBlock === i">
      <div class="p8-bdc_page-block_add-block">
        <p8-bdc-add-block-button (newBlock)="addBlock($event, i + 1)"></p8-bdc-add-block-button>
      </div>
    </div>

  </div>
</div>
